<template lang="pug">
//- v-row(no-gutters)
v-row.neutral200(no-gutters justify="center")
  //- v-col.pa-10(cols="3" xl="2")
    v-skeleton-loader(type="article@1" v-if="isFetching")
    .sticky.top-24.white(v-else)
      .text-md.font-semibold.neutral200.px-4.py-2.rounded-lg {{ $t('add_room_or_equipment')}}
      ul.mt-3.settings-side-menu
        template(v-for="menu in menus")
          router-link(:to="menu.target" v-slot="{ href, route, navigate, isActive, isExactActive }")
            li.py-2.px-4(@click="navigate" :class="isActive ? 'active' : ''") {{ menu.title }}
  
  //- v-col.neutral200.h-screen(cols="9" xl="10")
  v-col.h-screen(cols="9" xl="10")
    .neutral200
      v-container.pa-8(fluid style="width:85%")
        v-skeleton-loader(type="list-item-three-line@4" v-if="isFetching")
        template(v-else)
          .d-flex.align-center.mb-6
            v-btn.mr-4(icon small)
              v-icon(color="primary" @click="back") mdi-arrow-left
            .text-2xl.font-semibold {{ $t('add_room_or_equipment')}}

          v-card.round-xl.pa-6.mb-4#resource-detail(outlined)
            .mb-4
              .h8 {{ $t('resource_detail')}}
            v-row
              v-col(cols="12" md="6")
                .h9.mb-2 {{ $t('name') }}
                v-form(ref="form")
                  v-text-field.round-xl(v-model="name" :placeholder="$t('enter_item', { item: $t('name').toLowerCase() })" outlined dense height="48" hide-details="auto" :rules="rules.not_empty")
              v-col(cols="12" md="6")
                .h9.mb-2 {{ $t('type') }}
                y-select.mt-2(v-model="type" :items="facilityTypes" item-text="name" item-value="id" :placeholder="$t('select_type')")
              v-col(cols="12" md="6")
                .h9.mb-2 {{ $t('description') }} ({{ $t('optional') }})
                v-text-field.round-xl(v-model="description" :placeholder="$t('enter_item', { item: $t('description').toLowerCase() })" outlined dense height="48" hide-details="auto")

          //- v-card.round-xl.pa-6.mb-4#availability(outlined)
            .d-flex
              .flex-grow-1
                .h8 {{ $t('limit_time_availability')}}
                .text-sm {{ $t('limit_time_availability_description')}}
                  span Service settings 
              div
                y-switch(v-model="limitTimeAvailability")
            
            template(v-if="limitTimeAvailability")
              v-divider.my-4
              v-card.pa-6.round-xl(outlined)
                .text-md.font-medium {{ $t('set_weekly_hours') }}
                .mt-4
                  template(v-for="(schedule, scheindex) in schedules")
                    v-row(no-gutters :key="'schedule-' + scheindex")
        //- v-card.round-xl.pa-6.mb-4#availability(outlined v-if="Auth('page', '/admin/clinic/appointment')")
          .d-flex
            .flex-grow-1
              .h8 {{ $t('limit_time_availability')}}
              .text-sm {{ $t('limit_time_availability_description')}}
                span Service settings 
            div
              y-switch(v-model="limitTimeAvailability")
          
          template(v-if="limitTimeAvailability")
            v-divider.my-4
            v-card.pa-6.round-xl(outlined)
              .text-md.font-medium {{ $t('set_weekly_hours') }}
              .mt-4
                template(v-for="(schedule, scheindex) in schedules")
                  v-row(no-gutters :key="'schedule-' + scheindex")
                    v-col.shrink
                      div(style="min-width: 100px;")
                        y-checkbox.mt-3(v-model="schedule.enabled" @change="onCheck(schedule.day)")
                          template(#label)
                            div.text-md.font-semibold.text-uppercase.neutral700--text.ml-2 {{ schedule.day }}
                    template(v-if="schedule.slots.length > 0")
                      v-col
                        div.d-flex.mb-3(v-for="(slot, slindex) in schedule.slots" :key="'slot-' + slindex")
                          v-text-field.text-md.font-normal.round-xl(v-model="slot.begin" type="time" outlined :rules="rules.not_empty" dense height="48" hide-details="hide")
                          div.mt-3.mx-3 -
                          v-text-field.text-md.font-normal.round-xl(v-model="slot.end" type="time" outlined :rules="rules.not_empty" dense height="48" hide-details="hide")
                          v-btn.mt-3.ml-3(v-if="schedule.slots.length > 1" small icon @click="deleteSlot(slindex, schedule.slots)")
                            v-icon(color="neutral700" size="18") $yzi-trash-03
                      v-col.shrink
                        div(style="min-width: 100px;")
                          y-checkbox.mt-3(v-model="schedule.enabled" @change="onCheck(schedule.day)")
                            template(#label)
                              div.text-md.font-semibold.text-uppercase.neutral700--text.ml-2 {{ schedule.day }}
                      template(v-if="schedule.slots.length > 0")
                        v-col
                          div.d-flex.mb-3(v-for="(slot, slindex) in schedule.slots" :key="'slot-' + slindex")
                            v-text-field.text-md.font-normal.round-xl(v-model="slot.begin" type="time" outlined :rules="rules.not_empty" dense height="48" hide-details="hide")
                            div.mt-3.mx-3 -
                            v-text-field.text-md.font-normal.round-xl(v-model="slot.end" type="time" outlined :rules="rules.not_empty" dense height="48" hide-details="hide")
                            v-btn.mt-3.ml-3(v-if="schedule.slots.length > 1" small icon @click="deleteSlot(slindex, schedule.slots)")
                              v-icon(color="neutral700" size="18") $yzi-trash-03
                        v-col.shrink
                          div.d-flex.justify-end(style="min-width: 100px;")
                            v-btn.mt-3(small icon @click="addSlot(schedule.slots)")
                              v-icon(color="neutral700" size="18") $yzi-plus
                            v-menu(v-model="schedule.menu" offset-y left :close-on-content-click="false")
                              template(#activator="{ on, attrs }")
                                v-btn.mt-3.ml-3(small icon v-bind="attrs" v-on="on")
                                  v-icon(color="neutral700" size="18") $yzi-copy-03
                              v-card(min-width="250")
                                div.text-xs.font-bold.neutral700--text.px-4.py-3 {{ $t('copy_timing_to') }}...
                                template(v-for="copy in copySlot")
                                  v-divider
                                  div.px-4.py-3
                                    y-checkbox(v-model="copy.selected")
                                      template(#label)
                                        div.text-sm.neutral700-text.text-uppercase {{ copy.day }}
                                div.d-flex.align-center.px-4.py-3
                                  div.text-xs.font-semibold.underline.normal-case.neutral700--text.clickable(@click="clearCopySlot") {{ $t('clear') }}
                                  v-spacer
                                  v-btn.button-xs(color="neutral700" dark @click="copyTime(schedule)") {{ $t('apply') }}
                              
                      template(v-else)
                        v-col
                          div.text-md.neutral500--text.mt-3.mb-6 {{ $t('unavailable') }}
                    v-divider.mb-4(v-if="scheindex !== (schedules.length - 1)")

        //- v-card.round-xl.pa-6.mb-4#services(outlined v-if="Auth('page', '/admin/clinic/appointment')")
          .mb-6
            .h8 {{ $t('services')}}
            .text-sm {{ $t('facility_services_description')}}

            v-row.pb-2.pb-md-0(no-gutters)
              v-col(cols="12" md="6")
                v-tabs.mb-2.mb-md-0(color="basic700" height="44")
                  v-tab.text-sm.font-normal.text-none(active-class="font-semibold") All

              v-col(cols="12" md="6" align="end")
                .d-flex.align-center
                  v-spacer
                  v-btn(icon color="neutral500")
                    v-icon(size="20") $yzi-search-sm
                  assign-service-dropdown(:selectedServices="services" top @added="updateServices")
            v-divider.mb-6

          div(v-if="services.length === 0")
            v-card.round-xl.text-center.pa-8.border-dashed(outlined)
              v-avatar.mb-8(color="neutral300" size="54")
                v-icon(color="neutral500" size="30") $yzi-medical-cross
              .h8 You do not assign services yet.
              .text-sm.neutral500--text You can start assign services by clicking “+ Add service”
          div(v-else)
            v-simple-table
              thead.text-table-header
                tr
                  th Name
                  th Type
                  th Description
                  th Action
              tbody
                tr(v-for="(service, index) in services" :key="service.id")
                  td {{ service.name || service.product.name}}
                  td {{ service.type | capitalize }}
                  td.py-2 {{ service.product.description }}
                  td.text-right
                    v-btn.ml-4(icon small @click="deleteService(service)")
                      v-icon(color="neutral700" size="18") $yzi-trash-03
        //- .pa-12

      v-footer.white(app inset padless v-if="!isFetching")
        .d-flex.flex-column.grow
          v-divider
          .d-flex.justify-end.align-center.py-4.px-8
            y-button(:label="$t('cancel')" size="sm" color="primary" underline @click="back")
            y-button(:label="$t('save')" size="sm" color="primary" @click="save" :loading="isLoading")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AssignServiceDropdown from '@/components/clinic/appointment/custom/AssignServiceDropdown.vue'

export default {
  components: { AssignServiceDropdown },
  props: ['id'],
  data () {
    return {
      name: null,
      facilityTypes: [
        { name: 'Room', id: 'room' },
        { name: 'Equipment', id: 'equipment' }
      ],
      description: null,
      type: 'room',
      limitTimeAvailability: false,
      schedules: [
        { day: 'Sun', slots: [], enabled: false, menu: false },
        { day: 'Mon', slots: [], enabled: false, menu: false },
        { day: 'Tue', slots: [], enabled: false, menu: false },
        { day: 'Wed', slots: [], enabled: false, menu: false },
        { day: 'Thu', slots: [], enabled: false, menu: false },
        { day: 'Fri', slots: [], enabled: false, menu: false },
        { day: 'Sat', slots: [], enabled: false, menu: false }
      ],
      copySlot: [
        { day: 'Sun', selected: false },
        { day: 'Mon', selected: false },
        { day: 'Tue', selected: false },
        { day: 'Wed', selected: false },
        { day: 'Thu', selected: false },
        { day: 'Fri', selected: false },
        { day: 'Sat', selected: false }
      ],
      services: [],
      isLoading: false,
      isFetching: false,
      rules: {
        not_empty: [v => v && v.trim().length || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    menus () {
      const items = [{ target: '#resource-detail', title: 'Resource detail' }]
      if (this.Auth('page', '/admin/clinic/appointment')) {
        items.push({ target: '#availability', title: 'Availability' })
        items.push({ target: '#services', title: 'Services' })
      }
      return items
    }
  },
  mounted () {
    if (this.id) {
      this.fetchFacility()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchFacility () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/facilities/${this.id}`)
        .then(resp => {
          this.updateFacilityData(resp.data)
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
        })
    },
    updateFacilityData (data) {
      if (data) {
        this.name = data.name
        this.description = data.description
        this.limitTimeAvailability = data.schedule_enabled
        if (data.schedules.length > 0) {
          this.schedules = data.schedules
        }
        if (data.schedules.length > 0) {
          this.schedules = data.schedules.map(m => {
            let enabled = false
            if (m.slots.length > 0) {
              enabled = true
            }
            return { ...m, enabled, menu: false }
          })
        }
        this.services = data.services
      }
    },
    onCheck (day) {
      const selected = this.schedules.find(f => f.day === day)
      const index = this.schedules.findIndex(f => f.day === day)
      if (selected) {
        if (selected.slots.length > 0) {
          this.$set(this.schedules[index], 'slots', [])
        } else {
          this.schedules[index].slots.push({ begin: '09:00:00', end: '17:00:00' })
        }
      }
    },
    copyTime (schedule) {
      let newSlots = JSON.parse(JSON.stringify(schedule.slots.map(m => { return { begin: m.begin, end: m.end } })))
      let days = this.copySlot.filter(f => f.selected).map(m => m.day)
      days.forEach(o => {
        let getDay = this.schedules.find(f => f.day === o)
        if (getDay) {
          this.$set(getDay, 'slots', JSON.parse(JSON.stringify(newSlots)))
          this.$set(getDay, 'enabled', true)
        }
      })
      this.clearCopySlot()
      schedule.menu = false
    },
    clearCopySlot () {
      this.copySlot = [
        { day: 'Sun', selected: false },
        { day: 'Mon', selected: false },
        { day: 'Tue', selected: false },
        { day: 'Wed', selected: false },
        { day: 'Thu', selected: false },
        { day: 'Fri', selected: false },
        { day: 'Sat', selected: false }
      ]
    },
    addSlot (slots) {
      const lastSlot = slots[slots.length - 1]
      if (lastSlot.end) {
        const newBegin = Number(lastSlot.end.substr(0, 2)) + 1
        const newEnd = newBegin + 1
        const strNewBegin = newBegin.toString().length > 1 ? (newBegin.toString() + ':00:00') : '0' + (newBegin.toString() + ':00:00')
        const strNewEnd = newEnd.toString().length > 1 ? (newEnd.toString() + ':00:00') : '0' + (newEnd.toString() + ':00:00')
        if (newEnd < 24) {
          slots.push({ begin: strNewBegin, end: strNewEnd })
          return
        }
      }
      slots.push({ begin: null, end: null })
    },
    deleteSlot (index, slots) {
      slots.splice(index, 1)
    },
    updateServices (services) {
      services.forEach(service => {
        this.services.push(service)
      })
    },
    deleteService (service) {
      this.services = this.services.filter(item => item.id !== service.id)
    },
    back () {
      this.$router.push('/admin/clinic/settings/facilities')
    },
    save () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all')])
        return
      }
      this.isLoading = true
      const params = {
        name: this.name,
        type: this.type,
        description: this.description,
        schedule_enabled: this.limitTimeAvailability,
        services: this.services.map(i => i.id)
      }
      if (this.limitTimeAvailability) {
        params.schedules = this.schedules
      }
      if (this.id) {
        this.updateFacility(params)
      } else {
        this.createNewFacilty(params)
      }
    },
    createNewFacilty (params) {
      this.$axios.post(`/clinics/${this.company.slug}/facilities`, params)
        .then(() => {
          this.$router.push('/admin/clinic/settings/facilities')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateFacility (params) {
      this.$axios.patch(`/clinics/${this.company.slug}/facilities/${this.id}`, params)
        .then(resp => {
          this.updateFacilityData(resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>